import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $el = _ref.$el,
      $f7route = _ref.$f7route;
  var rows,
      editting_row = null;
  var table = 'kho_thoc_mau';
  var evt = $f7route.params.evt;

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_findAll',
              table: table,
              params: {
                where: 'deleted_at IS NULL'
              }
            });

          case 2:
            rs = _context.sent;
            rows = rs.rows;
            $update();

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  var clear = function clear() {
    $el.value.find('textarea[name="mo_ta"]').val('');
    $el.value.find('input[name="so_thoc"]').val('');
  };

  var save = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var mo_ta, so_thoc, rs, _rs;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              mo_ta = $el.value.find('textarea[name="mo_ta"]').val();
              so_thoc = parseInt($el.value.find('input[name="so_thoc"]').val());

              if (!(editting_row === null)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 5;
              return Base.call({
                method: '_post',
                table: table,
                params: {
                  mo_ta: mo_ta,
                  so_thoc: so_thoc
                }
              });

            case 5:
              rs = _context2.sent;
              rows.push(rs.row);
              _context2.next = 14;
              break;

            case 9:
              _context2.next = 11;
              return Base.call({
                method: '_put',
                table: table,
                params: {
                  id: editting_row.id,
                  mo_ta: mo_ta,
                  so_thoc: so_thoc
                }
              });

            case 11:
              _rs = _context2.sent;
              rows = rows.map(function (row) {
                return row.id === _rs.row.id ? _rs.row : row;
              });
              editting_row = null;

            case 14:
              clear();
              $update();

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function save() {
      return _ref3.apply(this, arguments);
    };
  }();

  var actions = function actions(row) {
    $f7.actions.create({
      buttons: [{
        text: 'Chọn',
        onClick: function onClick() {
          $f7.emit(evt, row);
          $el.value.find('.popup-close').click();
        }
      }, {
        text: 'Sửa',
        onClick: function onClick() {
          editting_row = row;
          $el.value.find('textarea[name="mo_ta"]').val(row.mo_ta);
          $el.value.find('input[name="so_thoc"]').val(row.so_thoc);
        }
      }, {
        text: 'Xoá',
        color: 'red',
        onClick: function onClick() {
          $f7.dialog.confirm('Xác nhận?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var rs;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return Base.call({
                      method: '_softDelete',
                      table: table,
                      params: {
                        id: row.id
                      }
                    });

                  case 2:
                    rs = _context3.sent;
                    rows = rows.filter(function (el) {
                      return el.id !== row.id;
                    });
                    $update();

                  case 5:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })));
        }
      }]
    }).open();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup popup-khothoc-template">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Mẫu mô tả lý do góp thóc</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".popup-khothoc-template"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">

          <div class="list no-margin">
            <ul>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Mô tả</div>
                  <div class="item-input-wrap">
                    <textarea name="mo_ta"></textarea>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Số thóc (1 hạt = 1.000đ)</div>
                  <div class="item-input-wrap">
                    <input type="number" name="so_thoc" />
                  </div>
                </div>
              </li>
              <li class="item-content">
                <div class="item-inner">
                    <a class="button button-fill" @click="${save}">Lưu lại</a>
                </div>
              </li>
            </ul>
          </div>

          <div class="card data-table margin-half">
            <table>
              <thead>
                <tr>
                  <th>Mô tả</th>
                  <th class="numeric-cell">Số thóc</th>
                </tr>
              </thead>
              <tbody>
                ${rows && rows.map(row=>$h`
                  <tr>
                    <td @click="${e=>actions(row)}">${row.mo_ta}</td>
                    <td class="numeric-cell">${row.so_thoc}</td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});